import React from 'react';
import { css } from '@emotion/css';
import { ShapesSvgDefaults } from 'utility/constants';
import { useTranslation } from './i18n';
import { Shape } from './shapeData/types.shapes';
import { ShapeSvg } from './SvgShapes';

export enum PreviewSize {
    Auto = 'Auto',
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large'
}

interface Props {
    shape: Shape | undefined;
    previewSize?: PreviewSize;
    isDraggable: boolean;
}

function getPreviewContainerCss(previewSize: PreviewSize, isDraggable: boolean) {
    let width;
    let cursor = 'default';
    if (isDraggable) {
        cursor = 'grab';
    }
    switch (previewSize) {
    case PreviewSize.Small:
        width = '120px';
        break;
    case PreviewSize.Medium:
        width = '170px';
        break;
    case PreviewSize.Large:
        width = '240px';
        break;
    default:
        width = '100%';
        break;
    }
    return css`
    width: ${width};
    height: ${width};
    display: flex;
    cursor: ${cursor};
    justify-content: center;
    ${isDraggable ? '&:active { cursor: grabbing}' : ''}`;
}

export function Preview({ shape, previewSize = PreviewSize.Auto, isDraggable }: Props): JSX.Element {
    const { t } = useTranslation();
    return (
        <div
            title={isDraggable ? t('dragShape') : undefined}
            className={`shape-preview ${getPreviewContainerCss(previewSize, isDraggable)}`}
        >
            {shape && (
                <ShapeSvg
                    shape={shape}
                    fillColor={ShapesSvgDefaults.fillColor}
                    stroke={ShapesSvgDefaults.stroke}
                    strokeWidth={ShapesSvgDefaults.strokeWidth}
                    width={ShapesSvgDefaults.viewBoxWidth}
                    height={ShapesSvgDefaults.viewBoxWidth}
                    isDraggable={isDraggable}
                />
            )}
        </div>
    );
}
